import { action, runInAction, computed } from "mobx";
import { FieldType, ViewModelBase, observable } from "@shoothill/core";
import { TestAndInspectionsTypesLookupModel } from "./TestAndInspectionsTypesLookupModel";
import { FormRequestDTO, TestAndInspectionsListAndRelatedDTO, TestAndInspectionsListModel } from "./TestAndInspectionsListModel";
import { AppUrls } from "AppUrls";

export class TestAndInspectionsListViewModel extends ViewModelBase<any> {
    @observable public projectId: string = "";
    @observable public testAndInspectionsFormType: TestAndInspectionsTypesLookupModel | null = null;
    @observable public testAndInspectionsTypes: any = [];
    @observable public testAndInspectionsListModels: TestAndInspectionsListModel[] = [];
    public constructor(projectId: string | null, date: any) {
        super();
        this.projectId = projectId!;
        this.model.createdDate = date.toISOString();
        this.loadTestAndInspectionsAndRelated();
    }

    @observable public errorMessage: string = "";

    @computed
    public get testAndInspectionsListItems() {
        const list = this.testAndInspectionsListModels.sort((a: any, b: any) => b.testAndInspectionNumber - a.testAndInspectionNumber);
        return list;
    }
    @action
    public setTestAndInspectionsForm = (type: TestAndInspectionsTypesLookupModel) => {
        this.testAndInspectionsFormType = type;
    };

    @action
    public referenceNumber = (item: any) => {
        let formattedNumber = item.toLocaleString("en-US", {
            minimumIntegerDigits: 8,
            useGrouping: false,
        });
        return formattedNumber;
    };

    @action
    public loadTestAndInspectionsAndRelated = async (): Promise<void> => {
        this.setIsLoading(true);
        const request: FormRequestDTO = {
            date: this.model.createdDate,
            projectId: this.projectId,
        };
        let apiResult = await this.Post<TestAndInspectionsListAndRelatedDTO>(
            AppUrls.Server.Projects.Construction.ProgrammeUpdates.TestAndInspections.GetTestAndInspectionsListByDate,
            request,
        );
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    this.testAndInspectionsTypes.replace(TestAndInspectionsTypesLookupModel.fromDtos(apiResult.payload.inspectionTypes));
                    this.testAndInspectionsListModels = [];
                    for (const testAndInspection of apiResult.payload.inspections) {
                        let model = new TestAndInspectionsListModel();
                        model.fromDto(testAndInspection);
                        this.testAndInspectionsListModels.push(model);
                    }
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
    };

    @action
    public handleRowClick = (e: any, rowData: TestAndInspectionsListModel) => {
        //this.history.push(AppUrls.Client.Project.Inspection.View.replace(":projectid", this.projectId).replace(":inspectionsId", rowData.id!));
    };

    public async isFieldValid(fieldName: keyof FieldType<any>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }
    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
